/**
 * 表格高度自适应 mixin
 *
 * 使用前提：
 * el-table 需设置 ref="tableDom"，通过 :height="tableHeight" 绑定高度
 *
 * 原理：
 * - mounted 时计算表格距离顶部距离，用窗口高度减去距离和分页器高度
 * - 监听窗口 resize 事件，实时更新高度
 * - beforeDestroy 时移除监听
 */
export const mixinTableHeight = {
  data() {
    return {
      tableHeight: 300,
    }
  },
  mounted() {
    this.calcTableHeight();
    window.addEventListener("resize", this.calcTableHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcTableHeight);
  },
  methods: {
    calcTableHeight() {
      this.$nextTick(() => {
        const table = this.$refs.tableDom;
        if (table) {
          let distance = 0;
          let el = table.$el;
          while (el.offsetParent) {
            distance += el.offsetTop;
            el = el.offsetParent;
          }
          this.tableHeight = window.innerHeight - distance - 60;
          if (table.doLayout) {
            table.doLayout();
          }
        }
      });
    },
  },
}
